import { render, staticRenderFns } from "./box-model-legend.vue?vue&type=template&id=2d31067e&"
import script from "./box-model-legend.vue?vue&type=script&lang=js&"
export * from "./box-model-legend.vue?vue&type=script&lang=js&"
import style0 from "./box-model-legend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports